import storeRegister from './storeRegister'

export const organizationId = () =>
  storeRegister.store.getState().organizations.activeOrganizationId

export const locationId = () => storeRegister.store.getState().locations.activeLocationId

export const positionId = () => storeRegister.store.getState().positions.activePositionId
